import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from '../../../../_services/customer.service';
import { DebtorService } from '../../../../_services/debtor.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, ExcelService, PreviousRouteService } from '../../../../_helpers/index';
import { ICustomer, DebtorsPatchRequest } from '../../../../_models/customer.interface';
import { DebtorsStatusEnum } from '../../../../_enums/index';
import { ParameterData } from '../../../../_helpers/index';
import { ActivatedRoute, Router } from '@angular/router';
import { debtordocumenttype, debtorTipo } from '../../../../_enums/debtordocumenttype';
import { BatchProcessUrls } from '../../../../_enums/urls';
import { DataService } from '../../../../_helpers/dataservice.service'
import { AuthService } from '../../../../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';
import { BackFilterService, ExcelDateConvertService } from '../../../../_services';
import { QueryParamsCustomerList } from '../../../../_models/queryparamslist.interface';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-old-customer-corporate-list',
  templateUrl: './old-customer-list.component.html',
  styleUrls: ['../../company/old-version/old-customer-list.component.css']
})
export class OldCustomerCorporateListComponent implements OnInit {

  public customer_public_id: string;
  excelExportData: any;
  ddldbtTipo: any[];
  ddldbdocumenttype: any[];

  auth0Profile: any;

  searchFilterForm: FormGroup;
  displayedColumns: string[] = ['creditor.name', 'created', 'name', 'email', 'document_id', 'phone', 'status'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  public iCustomer: ICustomer;
  debtorsPatchRequest: DebtorsPatchRequest[] = [];
  pageSize: number;
  PageSizeOptions: number[];
  isLoading = true;
  isadmin = false;
  paginatorIntl: any;
  isImport = false;
  customerStatus = 0;
  customerType = 0;
  searchValue = '';
  pageIndex: number = 0;
  pageStart: number = 0;
  totalSize: any;
  isExportExcelAvailable = true;
  backToSearch: any;
  tempSearch: any;
  previousUrl: any;
  filterType = new FormControl('0');
  filterStatus = new FormControl('TODOS');
  isBrowserBackButtonPressed: boolean = false;
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  queryParams: QueryParamsCustomerList = {};
  snapshotQueryParam: QueryParamsCustomerList = {};

  timerId: any;
  isExportDataAvailable:  undefined | any;
  isErrorExportAvailable: object | undefined;
  timeCompleted: boolean = false;
  exportSubscription$ : Subscription;
  baseURL: string;

  constructor
    (
      private customerService: CustomerService, private formBuilder: FormBuilder
      , private excelService: ExcelService, private parameterData: ParameterData
      , private router: Router, private debtorService: DebtorService
      , private ddldebtorTipo: debtorTipo, private documentType: debtordocumenttype
      , private dataService: DataService
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService
      , private backFilterService: BackFilterService
      , private previousRouteService: PreviousRouteService
      , private excelDateConvertService:ExcelDateConvertService
      , private activatedRoute: ActivatedRoute
    ) {
    this.spinnerService.show();

    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.ddldbdocumenttype = documentType.documenttype;
    this.ddldbtTipo = ddldebtorTipo.dbtTipo;
    this.isadmin = false;
    this.isImport = false;
    this.backFilterService.getCustomerSearchSharedData().subscribe(data => this.backToSearch = data);
    this.backFilterService.getIsBrowserBackButtonPressedSharedData().subscribe(data => this.isBrowserBackButtonPressed = data);
    this.baseURL = AppConfig.settings.apiServer.baseURL + BatchProcessUrls.URL_BATCHES_V1;
  }//end cons

  applyFilter() {

    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.filterValue = this.filterValue.trim();

    let filterVal = this.filterValue.split(':')[0];
    filterVal = filterVal.trim();
    if (filterVal == 'DNI' || filterVal == 'RUC' || filterVal == 'CEX' || filterVal == 'OTROS') {

      // this.dataSource.filter = this.filterValue.split(':')[1];
      this.searchValue = this.filterValue.split(':')[1].trim();;
    }
    else {
      // this.dataSource.filter = this.filterValue;
      this.searchValue = this.filterValue;
    }
    this.setBackToSearchFilter();
    this.getCorporateCustomerListFilterAndSearch(this.customerStatus, this.customerType, this.searchValue);
  }

  ngOnInit() {
    this.checkThisPageGrants();
    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";




    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');
      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
    }

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    
    //back to search start
    this.previousUrl = this.previousRouteService.getPreviousUrl();

    if ((this.isBrowserBackButtonPressed == true) &&
      (this.previousUrl.includes("/customers/")) &&
      (this.previousUrl.includes("/edit") || this.previousUrl.includes("/view"))
    ) {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.setBackToSearchData();
    } else {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.backFilterService.setCustomerSearchSharedData(null);
    }
    // back to search end

    this.searchFilterForm = this.formBuilder.group({
      searchText: [this.searchValue, Validators.required]
    });

    this.getCustomerDetails(this.customer_public_id, this.customerStatus, this.customerType, this.pageSize, this.pageStart, this.searchValue);
  }

  setBackToSearchData(){
    if (this.backToSearch != null) {
      this.searchValue = this.backToSearch.search;
      this.customerType = this.backToSearch.type;
      this.customerStatus = this.backToSearch.status;
      this.pageSize = this.backToSearch.pageSize;
      this.pageIndex = this.backToSearch.pageIndex;
      this.pageStart = this.backToSearch.pageStart;
      this.paginator.pageIndex = this.pageIndex;
      //set type dropdown value
      this.filterType.setValue(this.customerType);
      //set status dropdown value 
      if (this.customerStatus == 1) {
        this.filterStatus.setValue('Activos')
      } else if (this.customerStatus == 2) {
        this.filterStatus.setValue('Inactivos')
      } else {
        this.filterStatus.setValue('TODOS')
      }
      this.setBackToSearchFilter();
    }
  }
  
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);

  }

  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  getCustomerDetails(public_id: string, status: number, type: number, limit: number, start: number, search: string) {

    this.snapshotQueryParam = this.activatedRoute.snapshot.queryParamMap['params'];
    if (Object.entries(this.snapshotQueryParam).length != 0) {
  
        if (this.snapshotQueryParam["pageIndex"] != undefined) {
          if(this.snapshotQueryParam["pageIndex"] != ''){
            this.queryParams.pageIndex = this.snapshotQueryParam["pageIndex"];
          } else {
            this.queryParams.pageIndex = this.pageIndex;
          }
        };
  
        if (this.snapshotQueryParam["pageSize"] != undefined) {
          if(this.snapshotQueryParam["pageSize"] != '') {
            this.queryParams.pageSize = this.snapshotQueryParam["pageSize"];
          } else {
            this.queryParams.pageSize = this.pageSize;
          }
        };

        if (this.snapshotQueryParam["type"] != undefined) {
          this.queryParams.type = this.snapshotQueryParam["type"];
          this.setTypeFormBySnapshotQueryParam((this.queryParams.type).toString());
        };
  
        if (this.snapshotQueryParam["status"] != undefined) {
          this.queryParams.status = this.snapshotQueryParam["status"];
          this.setStatusFormBySnapshotQueryParam((this.queryParams.status).toString());
        };

        if (this.snapshotQueryParam["textSearch"] != undefined && this.snapshotQueryParam["textSearch"] != '') {
          this.queryParams.textSearch = this.snapshotQueryParam["textSearch"];
          this.searchFilterForm.get('searchText').setValue(this.queryParams.textSearch);
        };
        
        this.pageEvent(this.queryParams);
      } else {
        this.customerService.getCustomerList(public_id, status, type, limit, start, search).subscribe(data => {
          let resources = data["body"]["data"];
          this.isLoading = false;
          this.totalSize = data["body"]["records"];
          this.dataSource.data = resources;
          this.spinnerService.hide();
        }, error => {
          this.isLoading = false;
          console.log('Failed while trying to the Customer Search Result. ' + error);
        })        
      }
  }
  
  setTypeFormBySnapshotQueryParam(status: string) {
    switch (status) {
      case '0':
        this.filterType.setValue(0);
        break;
      case '1':
        this.filterType.setValue(1);
        break;
      case '2':
        this.filterType.setValue(2);
        break;
      default:
        this.filterType.setValue(0);
    }
  }

  setStatusFormBySnapshotQueryParam(status: string) {
    switch (status) {
      case '0':
        this.filterStatus.setValue('TODOS');
        break;
      case '1':
        this.filterStatus.setValue('Activos');
        break;
      case '2':
        this.filterStatus.setValue('Inactivos');
        break;
      default:
        this.filterStatus.setValue('TODOS');
    }
  }

  pageEvent(event) {
    this.spinnerService.show();
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;

    this.queryParams.pageIndex = event["pageIndex"].toString();
    this.queryParams.pageSize = event["pageSize"].toString();

    if (event["status"]) {
      this.queryParams.status = event["status"];
      this.customerStatus = this.queryParams.status;
    } else {
      this.queryParams.status = this.customerStatus;
    };

    if (event["type"]) {
      this.queryParams.type = event["type"];
      this.customerType = this.queryParams.type;
    } else {
      this.queryParams.type = this.customerType;
    };

    if (event["textSearch"] != undefined) {
      this.queryParams.textSearch = event["textSearch"];
      this.searchValue = this.queryParams.textSearch;
    };

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.queryParams,
      skipLocationChange: false,
      replaceUrl: true
    });

    this.customerService.getCustomerList(this.customer_public_id, this.customerStatus, this.customerType, this.pageSize, this.pageStart, this.searchValue).subscribe(data => {
      let resources = data["body"]["data"];
      this.isLoading = false;
      this.totalSize = data["body"]["records"];
      this.dataSource.data = resources;
      this.spinnerService.hide();
    }, error => {
      this.isLoading = false;
      this.spinnerService.hide();
      console.log('Failed while trying to the Customer Search Result. ' + error);
    });

    this.setBackToSearchFilter();
  }

  editDebtor(element) {
    this.router.navigate([`/customers/${element.public_id}/edit`]);
  }

  viewDebtorDetails(element) {

    this.router.navigate([`/customers/${element.public_id}/view`]);
  }//end


  filterCompanyDetails(event) {
    if (event == 0) {
      this.customerType = 0;
    }
    else if (event == 1) {
      this.customerType = 1;
    }
    else if (event == 2) {
      this.customerType = 2;
    } else {
      this.customerType = 0;
    }
    this.getCorporateCustomerListFilterAndSearch(this.customerStatus, this.customerType, this.searchValue);
    this.setBackToSearchFilter();
  }

  filterStatusDetails(event) {
    if (event == 'TODOS') {
      this.customerStatus = 0;
    }
    else if (event == 'Activos') {
      this.customerStatus = 1;
    }
    else if (event == 'Inactivos') {
      this.customerStatus = 2;
    } else {
      this.customerStatus = 0;
    }
    this.getCorporateCustomerListFilterAndSearch(this.customerStatus, this.customerType, this.searchValue);
    this.setBackToSearchFilter();
  }

  getCorporateCustomerListFilterAndSearch(status: number, type: number, searchValue) {
    this.pageIndex = 0;
    this.setBackToSearchFilter();
    this.queryParams.pageIndex = this.pageIndex;
    this.queryParams.pageSize = this.pageSize;
    this.queryParams.status = status;
    this.queryParams.type = type;
    if (searchValue != '') {
      this.queryParams.textSearch = searchValue;
    } else {
      const { textSearch, ...queryParamsObject } = this.queryParams;
      this.queryParams = queryParamsObject;
    }
    this.pageEvent(this.queryParams);
  }


  // filterCompanyDetails(event) {

  //   if (event == 0) {

  //     this.dataSource.filter = '';
  //   }
  //   else if (event == 1) {
  //     this.dataSource.filter = '';

  //     this.dataSource.filterPredicate = (data: ICustomer, filter: string) =>
  //       data.document_type == filter;

  //     this.dataSource.filter = '2';
  //   }
  //   else {
  //     this.dataSource.filter = '';

  //     this.dataSource.filterPredicate = (data: ICustomer, filter: string) =>
  //       data.document_type != filter;
  //     this.dataSource.filter = '2';
  //   }


  // }//end

  // filterStatusDetails(event) {
  //   if (event == 'TODOS') {
  //     this.dataSource.filter = '';
  //   }
  //   else if (event == DebtorsStatusEnum.STATUS_SPN) {
  //     this.dataSource.filter = '';
  //     this.filterValue = DebtorsStatusEnum.ACTIVETEXT;

  //     this.dataSource.filterPredicate = (data: ICustomer, filter: string) =>
  //       data.status.toLowerCase() == filter;

  //     this.dataSource.filter = this.filterValue.trim().toLowerCase();
  //   }

  //   else {
  //     this.dataSource.filter = '';
  //     this.filterValue = DebtorsStatusEnum.INACTIVETEXT;

  //     this.dataSource.filterPredicate = (data: ICustomer, filter: string) =>
  //       data.status.toLowerCase() == filter;

  //     this.dataSource.filter = this.filterValue.trim().toLowerCase();
  //   }

  // }//end


  /**
  * this function is used to get the Document type Name.
  * input parameter is document type Id value, which is number and returns document type name
  */
  getDocumentType(idValue) {

    if (idValue == "1") {
      return "DNI";
    }
    if (idValue == "2") {
      return "RUC";
    }
    if (idValue == "3") {
      return "CEX";
    }
    if (idValue == "4") {
      return "OTROS";
    }
  }//end



  // getDateMoment(val) {
  //   var dateForma = moment(val).format("DD-MM-YYYY");
  //   return dateForma;
  // }

  checkResponseExportTime() {
    this.timerId = setTimeout(() => {
      if (this.isExportDataAvailable == undefined && this.isErrorExportAvailable == undefined) {
        this.spinnerService.hide();
        this.timeCompleted = true;
        this.exportSubscription$.unsubscribe();
      }
    }, 11000);
  }

  reportExport() {
    this.spinnerService.show();
    clearTimeout(this.timerId);
    this.isExportDataAvailable = undefined;
    this.isErrorExportAvailable = undefined;
    this.checkResponseExportTime();
    let customerStatusString = this.customerStatus.toString();
    let customerTypeString = this.customerType.toString();

    this.exportSubscription$ = this.customerService.reportExport(this.customer_public_id, customerStatusString, customerTypeString, this.searchValue).subscribe(data => {
      this.isExportDataAvailable = data;
      if (data.storage_url != undefined) {
        location.href = data.storage_url;
      } else {
        console.log(data);
      }
      this.spinnerService.hide();
    }, err => {
      this.isLoading = false;
      this.spinnerService.hide();
      this.isErrorExportAvailable = err;
      console.log('Failed while trying to the Customer Export.' + err.error);
    });
  }

  closeModal() {
    this.timeCompleted = false;
  };

  setExportExcelFileData(excelExportData) {
    //var excelHeader = ["Empresa", "FECHA CREACION", "NUMERO DOCUMENTO", "DOCUMENTO", "EMAIL", "ID Cliente", "NOMBRE", "TELEFONO", "ESTADO"]
    //var columnsKeyNames = ["creditor", "created", "document_id", "document_type", "email", "external_id", "name", "phone", "status"]
    var excelHeader = ["EMPRESA","FECHA CREACION", "NOMBRE", "EMAIL", "DOCUMENTO", "NUMERO DOCUMENTO", "TELEFONO", "ESTADO"]

    var arrFinalData = [];
    var object_temp = {};
    var k = 0;
    var columnsKeyNames = [];

    for (k = 0; k < excelExportData.length; k++) {
      var singleRec_temp = excelExportData[k];
      var creditor_temp;
      var created_temp;
      var documentid_temp;
      var document_type_temp;
      var email_temp;
      var externalid_temp;
      var name_temp;
      var phone_temp;
      var status_temp;

      columnsKeyNames = Object.keys(singleRec_temp);


      object_temp = {};

      for (var i = 0; i < columnsKeyNames.length; i++) {


        if (columnsKeyNames[i] == "creditor") {
          creditor_temp = singleRec_temp[columnsKeyNames[i]].name;
        }

        if (columnsKeyNames[i] == "created") {
          created_temp = singleRec_temp[columnsKeyNames[i]];
        }
        if (columnsKeyNames[i] == "document_id") {
          documentid_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "document_type") {
          document_type_temp = this.getDocumentType(singleRec_temp[columnsKeyNames[i]]);
        }

        if (columnsKeyNames[i] == "email") {
          email_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "external_id") {
          externalid_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "name") {
          name_temp = singleRec_temp[columnsKeyNames[i]];
        }


        if (columnsKeyNames[i] == "phone") {
          phone_temp = singleRec_temp[columnsKeyNames[i]];
        }
        var statusEnglish;
        if (columnsKeyNames[i] == "status") {
          statusEnglish = singleRec_temp[columnsKeyNames[i]];

          switch (statusEnglish) {
            case 'ACTIVE':
              status_temp = 'Activo'
              break;
            case 'INACTIVE':
              status_temp = 'Inactivo'
              break;
          }



        }
      }

    //   for (var j = 0; j < excelHeader.length; j++) {

    //     if (excelHeader[j] == "Empresa") {
    //       object_temp[excelHeader[j]] = creditor_temp;
    //     }

    //     if (excelHeader[j] == "FECHA CREACION") {
    //       object_temp[excelHeader[j]] = created_temp;
    //     }

    //     if (excelHeader[j] == "NUMERO DOCUMENTO") {
    //       object_temp[excelHeader[j]] = documentid_temp;
    //     }

    //     if (excelHeader[j] == "DOCUMENTO") {
    //       object_temp[excelHeader[j]] = document_type_temp;
    //     }

    //     if (excelHeader[j] == "EMAIL") {
    //       object_temp[excelHeader[j]] = email_temp;
    //     }

    //     if (excelHeader[j] == "ID EMPRESA") {
    //       object_temp[excelHeader[j]] = externalid_temp;
    //     }

    //     if (excelHeader[j] == "NOMBRE") {
    //       object_temp[excelHeader[j]] = name_temp;
    //     }
    //     if (excelHeader[j] == "TELEFONO") {
    //       object_temp[excelHeader[j]] = phone_temp;
    //     }


    //     if (excelHeader[j] == "ESTADO") {
    //       object_temp[excelHeader[j]] = status_temp;
    //     }


    //   }//end for


    //   arrFinalData.push(object_temp);
      arrFinalData.push([creditor_temp, this.excelDateConvertService.convertExcelDateTime(created_temp), name_temp, email_temp, document_type_temp, documentid_temp, phone_temp, status_temp]);
     }

     this.excelService.generateCustomersExcelFile(excelHeader, arrFinalData, 'CustomerList', localStorage.getItem('application'));


  }//end function

  // convertExcelGMTTime(value) {
  //   var dateTimeZoneDiff = value.split(/[- :]/),
  //     dateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
  //   dateFinal.setMilliseconds(Number(this.offsetTimeVal));
  //   var dateString = moment(dateFinal).format('MM/DD/YYYY HH:mm:ss');
  //   var dateObj = new Date(dateString);
  //   var momentObj = moment(dateObj);
  //   var momentString = momentObj.format('DD/MM/YYYY HH:mm:ss'); // 2016-07
  //   return momentString;
  // }

  viewDashboard(element) {
    localStorage.setItem('isCorporateCompany', "Yes");
    localStorage.removeItem('accessmenu');
    this.GetSubCompanyName(element);
    localStorage.setItem('subcompanyId', element.creditor.public_id);
    this.router.navigate([`/dashboardcallback`]);
  }//end

  GetSubCompanyName(element) {

    this.customerService.getCustomerCompanyDetailsList(element.creditor.public_id).subscribe(d => {
      localStorage.setItem('isCorporate', 'Yes');
      localStorage.setItem('customername', d.body.name);
      this.dataService.changeuserprofilename(localStorage.getItem('customername'));
    },
      error => {

      });

  }

  async checkThisPageGrants() {
    await this.auth.isKashioGrantsAvailable();
    this.isExportExcelAvailable = this.auth.checkGrants('CUSTOMERS', 'EXPORT');
  }

  setBackToSearchFilter() {
    this.tempSearch = {
      search: this.searchValue,
      type: this.customerType,
      status: this.customerStatus,
      pageSize: this.pageSize,
      pageIndex:this.pageIndex,
      pageStart: this.pageStart
    }
    this.backFilterService.setCustomerSearchSharedData(this.tempSearch);
  }
}//end class


